<template>
    <div class="taxes">
        <div class="box-white-wrapper">
            <vs-table search :data="systemParameters" pagination max-items="20">
                <template slot="thead">
                    <vs-th sort-key="code">Código </vs-th>
                    <vs-th sort-key="name">Nombre</vs-th>
                    <vs-th sort-key="value">Descripción</vs-th>
                    <vs-th sort-key="id"></vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                        <vs-td :data="data[indextr].code">
                             {{data[indextr].code }}
                        </vs-td>
                        <vs-td :data="data[indextr].name">
                            {{data[indextr].name}}
                        </vs-td>
                        <vs-td :data="data[indextr].value">
                            {{data[indextr].value}}
                        </vs-td>
                        <vs-td :data="data[indextr].code">
                            <div class="table-actions">
                                <a href="javascript:void(0)" @click="editConfig(data[indextr].code)"><feather type="edit-2"/></a>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <transition name="fade">
                <ModalBasic :show="ModalActive">
                    <div class="modal-header" slot="modal-header">{{ ModalTitle }}</div>
                    <div class="modal-body" slot="modal-body">
                        <form>
                            <vs-textarea :maxlength="maxlength" :counter="maxlength" :counter-danger.sync="counterDanger" v-model="$v.config.value.$model" />
                        </form>
                    </div>
                    <div class="modal-footer" slot="modal-footer">
                        <vs-button color="danger" type="border" icon="block"  @click="closeModal()">Cancelar</vs-button>
                        <vs-button :disabled="confirmStatus || $v.$invalid" id="btnConfirm" color="success" type="border" icon="check" 
                            @click="updateConfig" class="vs-con-loading__container"> {{ !isUpdating ? 'Guardar' : 'Actualizar' }}</vs-button>
                    </div>
                </ModalBasic>
            </transition>
        </div>
    </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import ConfigurationModel from '@/models/ConfigurationModel';
import ConfigurationDataService from "@/services/ConfigurationDataService";
import ModalBasic from '@/components/Modal/Basic.vue'
import { required } from 'vuelidate/lib/validators'
export default {
    name: 'Configuration',
    mixins: [helper],
    components: {
      ModalBasic
    },
    data() {
      return {
        systemParameters:[],
        config: new ConfigurationModel(),
        ModalTitle: 'Editar Valor',
        ModalActive: false,
        confirmStatus: false,
        isUpdating: false,
        maxlength: 260,
        counterDanger: false,
        buttonsHidden: false,
      
      }
    },
    validations: {
        config: 
            { 
                code: { required },
                name: { required },
                value: { required }
            },
    },
    beforeMount() {
        this.$Progress.start();
    },
    mounted () {
      this.retrieveConfig();
    },
    methods:{
        openModal () {
          this.config    = new ConfigurationModel()
          this.ModalActive = true
          this.isUpdating  = false
          this.$v.$reset()
        },
        closeModal () {
          this.ModalTitle  = 'Nuevo Valor'
          this.ModalActive = false
          this.config    = new ConfigurationModel()
          this.$v.$reset()
        },
        editConfig (id) {
          console.log(id)
          this.ModalTitle  = "Editar Valor"
          this.config = this.searchParameter(id);
          this.ModalActive = true
          this.isUpdating  = true
        },
        retrieveConfig() {
            ConfigurationDataService.getAll()
            .then(response => {
                this.systemParameters = response.data;
                this.$Progress.finish()
            })
            .catch(e => {
                console.log(e);
                this.$Progress.finish()
                this.$vs.notify({title:'Error!',text:'Error obteniendo los parámetros del sistema!',color:'danger',icon:'error_outline'})
            });
        },
        updateConfig(){
            this.$v.$touch()
            if (this.$v.$invalid) return;
            const that = this
            that.loadingProgress ('#btnConfirm')
            that.confirmStatus = true
            ConfigurationDataService.update(that.config)
            .then( () => {
                that.confirmStatus = false
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.ModalActive = false
                that.$vs.notify({title:'Información!',text:'El valor del parámetro fue modificado exitosamente!',color:'success',icon:'check'})
                that.config = new ConfigurationModel()
                this.retrieveConfig()
                this.$v.$reset()
            })
            .catch(e => {
                console.log(e)
                that.ModalActive = false
                that.confirmStatus = false
                that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
                that.$vs.notify({title:'Información!',text:'Error actualizando el parámetro del sistema',color:'danger',icon:'error_outline'})
            });
        },
        searchParameter (_code) {
            let obj = this.systemParameters.filter((item) => {
              return _code === item.code
            })
            obj =  obj[0]
            let tax = new ConfigurationModel(obj.code, obj.name, obj.value);
  
            return tax
        }
    }
}
</script>
